// cognition-page-header.tsx
// AI Reasoning Path header: thin wrapper over the shared ModuleHeader band.

import { GitBranch } from "lucide-react";
import { ModuleHeader } from "../shell/module-header";

export function CognitionPageHeader() {
  return (
    <ModuleHeader
      page="AI Reasoning Path"
      icon={GitBranch}
      title="Why the models choose."
      description="Follow how each model interprets a question, gathers evidence, and lands on a recommendation."
    />
  );
}
